﻿import { ConfiguratorDI, Enumerable, Kbo } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObject } from "@models/configurators/kb-object";
import { PartMaterial } from "@models/configurators/part-material";
import { PartOperation } from "@models/configurators/part-operation";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IDummyNode } from "@models/configurators/kb-object";
import { UiObject } from "@models/configurators/ui-object";

@Kbo(CToken.BistrackPartRev)
export class BistrackPartRev extends KbObject {
    constructor(kom: KbObjectManager, data?: any) {
        super(kom);
    }
}